<fieldset [disabled]="editable">
	<mat-table #dataTable *ngIf="data.optionalTripLocations" [dataSource]="data.optionalTripLocations">
		<ng-container matColumnDef="name">
			<mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
			<mat-cell *matCellDef="let element"
				>{{ element.location.name
				}}<small *ngIf="element.location.parentLocation?.name"
					>&nbsp; ({{ element.location.parentLocation?.name }}
					{{ element.location.parentLocation?.parentLocation?.name }})</small
				></mat-cell
			>
		</ng-container>

		<ng-container matColumnDef="code">
			<mat-header-cell *matHeaderCellDef> Kod </mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ element.location.code }}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="kind">
			<mat-header-cell *matHeaderCellDef> Rodzaj lokalizacji </mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ element.location.locationKind }}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="edit">
			<mat-header-cell *matHeaderCellDef></mat-header-cell>
			<mat-cell *matCellDef="let element; let i = index">
				<button mat-raised-button color="warn" [disabled]="editable" (click)="deleteLocation(i)">
					<i class="fa-solid fa-trash-can"></i> Wyczyść lokalizacje
				</button>
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
	</mat-table>
	<div *ngIf="!data.optionalTripLocations.length" class="alert mt-4 alert-warning text-center">Brak lokalizacji</div>
	<div class="d-flex justify-content-end m-3">
		<button class="me-3" color="primary" [disabled]="editable" mat-raised-button (click)="dialogForm()">
			Dodaj lokalizacje
		</button>
	</div>
</fieldset>
